var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip294_4335"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Property 1=ds_ic_24_chevron_right",
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip294_4335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.23 7.25C7.91 6.93 7.91 6.4 8.23 6.07C8.56 5.75 9.08 5.75 9.41 6.07L13.33 10L9.41 13.92C9.08 14.24 8.56 14.24 8.23 13.92C7.91 13.59 7.91 13.06 8.23 12.74L10.98 10L8.23 7.25Z",
    fill: "#50964E",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight);
export default __webpack_public_path__ + "static/media/ic_arrow_right.e9ae5687ee28bd3799b680a183585654.svg";
export { ForwardRef as ReactComponent };